// views/Components/Loader.js
// Kept for its existing call sites. The implementation is the shared one in
// components/Loading.jsx — this used to be a 100px ring in `currentColor`,
// which is invisible inside any panel with a light text colour.
import React from "react";
import Loading from "../../components/Loading";

const Loader = () => <Loading size="page" />;

export default Loader;
